<!--AFFICHAGE BLOC GOOGLE -->
<template>
   <v-container v-if="this.condition()" fluid>
          <v-row dense>
            <v-col cols="12">
    <v-card v-if="this.condition()" elevation="2">
      <v-card-title>
        <v-icon large left> mdi-google</v-icon>
        Info Google
      </v-card-title>

      <v-list two-line>
        <v-list-item v-if="this.condition_score()">
          <v-list-item-content>
            <v-list-item-title
              ><a v-bind:href="this.score.review_link" target="_blank"
                >Score : {{ this.score.stars }} pour
                {{ this.score.review_nb }} vote(s)</a
              ></v-list-item-title
            >

            <v-rating
              v-model="this.score.stars"
              half-increments
              length="5"
              readonly
            ></v-rating>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item v-if="horaires">
        <v-list-item-content>
          <v-list-item-title>Horaires d'ouverture</v-list-item-title>
          <v-data-table
            dense
            :headers="headers"
            :items="horaires"
            item-key="jour"
            class="elevation-1"
            hide-default-header
            hide-default-footer
          >
          </v-data-table>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-col>
          </v-row>
   </v-container>
</template>

<script>
export default {
  name: "GoogleScore",
  props: ["etablissement"],
  components: {},
  computed: {
    score: function () {
      return this.$store.getters.getbloc("info", "indicateurs").score_google
        .valeur;
    },
    google: function () {
      return this.$store.getters.getbloc("info", "indicateurs");
    },
    horaires: function () {
      var horaires = this.$store.getters.getbloc("info", "indicateurs","horaires")
      if (horaires && horaires.valeur) {
        return horaires.valeur.libelle
      }
      return null
    },
    headers() {
      return [
        {
          text: "jour",
          value: "jour",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "ouverture",
          value: "ouverture",
          align: "start",
          fixed: true,
          width: "100px",
        },
      ];
    },
  },

  methods: {
    condition() {
      return this.$store.getters.condition("info", "indicateurs","score_google" );
    },
    condition_score() {
      return (
        this.$store.getters.condition("info", "indicateurs", "score_google") &&
        this.etablissement.info.indicateurs.score_google.valeur.stars != null
      );
    },
  },
};
</script>
